import React from 'react';
import { translate } from 'react-i18next';

const InlineLoader = ({t}) => {
    return (
        <div className="loader-inline" style={{fontStyle: 'italic', fontWeight: 'bold'}}>
            {t('loading')}...
        </div>
    );
};

export default translate()(InlineLoader);

